import { createClient, type SupabaseClient } from '@supabase/supabase-js';

const url = import.meta.env.VITE_SUPABASE_URL ?? '';
const publishableKey = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY ?? '';

let companyClient: SupabaseClient | null = null;
let adminClient: SupabaseClient | null = null;

function assertConfig(): void {
  if (!url || !publishableKey) {
    throw new Error(
      'Supabase client unavailable: set VITE_SUPABASE_URL and VITE_SUPABASE_PUBLISHABLE_KEY',
    );
  }
}

// Company portal session (email + password; detectSessionInUrl stays true so
// the password-recovery fragment on /c/reset-password is picked up). Distinct
// storage key so admin and company sessions can coexist in the same browser.
export function getSupabase(): SupabaseClient {
  if (!companyClient) {
    assertConfig();
    companyClient = createClient(url, publishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
        storageKey: 'l2u-company-auth',
      },
    });
  }
  return companyClient;
}

// Admin portal session (email + password). Separate storage key.
// detectSessionInUrl must stay false: if true, the admin client would steal
// the company recovery-link hash on /c/reset-password and later sign out,
// revoking the shared refresh token.
export function getAdminSupabase(): SupabaseClient {
  if (!adminClient) {
    assertConfig();
    adminClient = createClient(url, publishableKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: false,
        storageKey: 'l2u-admin-auth',
      },
    });
  }
  return adminClient;
}
